<template>
  <div>
    <vx-card no-shadow>
      <div class="vx-row mb-6 mt-2">
        <div class="vx-col sm:w-4/5 w-full">
          <vs-row>
            <h4>Guest log (legacy)</h4>
            <vs-chip class="ml-2">{{ globalLogs.length }}</vs-chip>
          </vs-row>
          <p class="text-sm">This is the legacy log primarily stating events prior to guest migration.</p>
        </div>
      </div>

      <vs-row v-if="isLoading" class="justify-center">
        <Loading />
      </vs-row>
      <vs-row v-else>
        <ul class="vx-timeline">
          <li v-for="(log, idx) in globalLogs" :key="idx" class="cursor-pointer">
            <div class="timeline-icon" :class="`bg-${logItemColor(log)}`">
              <feather-icon icon="ChevronRightIcon" svgClasses="text-white w-5 h-5" />
            </div>
            <div class="timeline-info">
              <p class="font-semibold">{{ log.title }}</p>
              <!--       <p class="whitespace-pre-wrap break-words">{{ logItemDescription(log) }}</p> -->
            </div>
            <small class="text-grey activity-e-time"> {{ log.timestamp | formatDate }} - {{ log.priority }} - {{ log.source }} </small>
          </li>
        </ul>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {},

  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      globalLogs: "globalLogs/globalLogsForGuest",
      isLoading: "globalLogs/isLoading"
    })
  },
  methods: {
    logItemColor(item) {
      switch (item.priority) {
        case "Warning":
          return "success";
        case "Error":
          return "danger";
        default:
          return "primary";
      }
    },

    logItemIcon(item) {
      switch (item.priority) {
        case "Warning":
          return "AlertTriangleIcon";
        case "Error":
          return "AlertTriangleIcon";
        default:
          return "ChevronRightIcon";
      }
    },

    logItemDescription(item) {
      switch (item.aggregateType) {
        case "consentChanged":
          return `Lightbooth removed phone consent for ${item.venueName}`;
        case "guestMergeLog":
          return "The information of this guest was updated by stiching together two guests.";
        case "automationExecutedLog":
          return `The automation "${item.automationName}" was executed.`;
        case "automationRuntimeActionLog":
          switch (item.runtimeAction.action._type) {
            case "SendMailAction":
              var template = this.emailTemplate(item.runtimeAction.action.templateId);
              return `The email "${template.name}" was sent to the guest.`;
            default:
              return `The automation action "${item.runtimeAction.action._type}" was executed.`;
          }
        default:
          return `Log: ${item.aggregateType}`;
      }
    },

    emailTemplate(templateId) {
      return this.$store.getters["emailTemplates/emailTemplate"](templateId);
    }
  },
  async created() {
    this.profileId = this.$route.params.id;
    await this.$store.dispatch("globalLogs/getForGuest", this.profileId);
    console.log("globalLogs", this.globalLogs, this.profileId);

    await this.$store.dispatch("emailTemplates/getAll");
  }
};
</script>


<style lang="scss" scoped>
.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}
</style>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>